import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const TaggleVideo = lazy(() => import(/* webpackChunkName: "TaggleVideo" */ './components/TaggleVideo'));

const taggleVideos = document.querySelectorAll('[data-taggle-video]');
if (taggleVideos != null) {
    taggleVideos.forEach((taggleVideo, index) => {
        const props = parseDatasetToProps(taggleVideo.dataset);

        render(
            <Suspense fallback={<></>}>
                <TaggleVideo
                    key={index}
                    {...props}
                />
            </Suspense>,
            taggleVideo
        );
    });
}
